/* eslint-disable no-param-reassign */
import { getSpecificParent } from '@apia/util';
import { DragAndDrop } from '../util/DragAndDrop';

export function dragstart(
  ev: DragEvent,
  el: Element,
  DragAndDrop: DragAndDrop,
) {
  if (!(el instanceof HTMLElement)) return;
  DragAndDrop.drawMinimap();
  DragAndDrop.sectionData = [];

  const targetPanel = getSpecificParent(
    ev.target as HTMLElement,
    (current) => !!current.dataset?.id && !!current.dataset?.panel,
  );

  ev?.dataTransfer?.setData('text', targetPanel?.dataset.id as string);
  if (targetPanel) {
    DragAndDrop.placeholderImage = targetPanel.cloneNode(true) as HTMLElement;
    DragAndDrop.placeholderImage.style.position = 'fixed';
    DragAndDrop.placeholderImage.style.top = '-10000000.45px';

    const children =
      DragAndDrop.placeholderImage.querySelectorAll<HTMLElement>('*');
    children.forEach((current) => (current.style.overflow = 'hidden'));
    document.body.append(DragAndDrop.placeholderImage);
    ev?.dataTransfer?.setDragImage(DragAndDrop.placeholderImage, 0, 0);
  }
  if (ev.dataTransfer) {
    // eslint-disable-next-line no-param-reassign
    ev.dataTransfer.effectAllowed = 'move';
  }

  setTimeout(() => {
    const targetSection = getSpecificParent(
      ev.target as HTMLElement,
      (current) => !!current.dataset?.locationid,
    );

    const sections = DragAndDrop.body?.querySelectorAll('[data-locationid]');

    const emptySectionsId: string[] = [];

    sections?.forEach((sec) => {
      if (sec.children.length === 0) {
        emptySectionsId.push((sec as HTMLElement).dataset.locationid ?? '');
      }
    });

    emptySectionsId.forEach((emptySecId) => {
      const section = DragAndDrop.body?.querySelector(
        `[data-locationid="${emptySecId}"]`,
      );
      if (section) {
        section.setAttribute('style', 'padding: 10px; border:2px dashed #ccc');
      }
    });

    DragAndDrop.snapshot();

    if (targetPanel) {
      DragAndDrop.draggingPanelSectionId =
        targetSection?.dataset.locationid ?? '';
      DragAndDrop.draggingPanelId = targetPanel.dataset.id as string;
      DragAndDrop.draggingPanel = targetPanel;
    }
    if (DragAndDrop.draggingPanelId === '') {
      return;
    }
    const falseDiv = targetPanel?.cloneNode(true) as HTMLDivElement;
    falseDiv.style.opacity = `50%`;
    falseDiv.style.width = `100%`;
    falseDiv.style.height = `auto`;
    falseDiv.style.backgroundColor = `rgba(0,0,0,0.1)`;
    falseDiv.className = 'apia_panel_falseDiv';
    DragAndDrop.shadowDiv = falseDiv;
  }, 0);
}
